import React, { useState, useEffect } from "react";
import "./style.scss";
import { useHistory } from "react-router-dom";
import { getViewApplicationData } from "./dependencies/action";
import MentorImg from "../../../../../assets/images/tm-4.jpg";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import hashImage from "../../../../../assets/images/hashImage.jpeg";

import api from "../../../../common/dependencies/utils/Api";
import { Button } from "@material-ui/core";
import { VIEW_STARTUP_APPLICATION_DATA } from "../../../../common/constants/ApplicationUrl";
const ViewApplicationStartup = (props) => {
  const imageUrl = process.env.REACT_APP_DOC_URL;
  const [viewApplicationData, setViewApplicationData] = useState();
  const [students, setStudents] = useState([]);
  const [students1, setStudents1] = useState([]);
  const history = useHistory();
  const loggedInUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const handleClick = () => {
    // history.goBack();
    if (props.location.state.fromModule === "mentorStartRequest") {
      localStorage.setItem("myrequestMenu", "myrequestMenu");
      history.push("./dashboard");
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    // const params = { id: props.location.state };
    let params;
    if (window.id != undefined && window.id != null && window.id != "") {
      params = { id: window.id };
    } else {
      let applnId = window.location.pathname.split("/")
    
      params = { id: applnId[applnId.length-1] };
    }
  
    api
      .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data) setViewApplicationData(response.data.data);
        } else {
        }
      })
      .catch((e) => {});
  }, []);
  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  useEffect(() => {
    let formattedNumber = viewApplicationData?.contact_no.substr(
      2,
      viewApplicationData?.contact_no.length
    );
    let newNumber = "91" + " " + formattedNumber;
    let value = []
    if(loggedInUser?.role === "Admin" || loggedInUser?.id == viewApplicationData?.id)
     value = [
      {
        question: "Entity Name",
        answser: viewApplicationData && viewApplicationData.entity_name,
      },
      {
        question: "DPIIT Number",
        answser: viewApplicationData && viewApplicationData.dpiit_no,
      },
      {
        question: "Sector",
        answser: viewApplicationData && viewApplicationData.sector,
      },
      {
        question: "Industry",
        answser: viewApplicationData && viewApplicationData.industry,
      },
      {
        question: "Function",
        answser: viewApplicationData && viewApplicationData.services?viewApplicationData.services:"NA",
      },
      {
        question: "Stage",
        answser: viewApplicationData && viewApplicationData.stage,
      },
      {
        question: "Applicant Name",
        answser: viewApplicationData && viewApplicationData.applicant_name,
      },
      { 
        question: "Email",
        answser: viewApplicationData && viewApplicationData.email_id,
      },
      // {
      //   question: "Contact Number",
      //   // answser: viewApplicationData && viewApplicationData.contact_no,
      //   answser: viewApplicationData && "+" + newNumber,
      // },
      {
        question: "Designation",
        answser: viewApplicationData && viewApplicationData.designation,
      },
      {
        question: "Gender",
        answser: viewApplicationData && viewApplicationData.gender,
      },
      {
        question: "Country",
        answser: viewApplicationData && viewApplicationData.country_name,
      },
      {
        question: "State",
        answser: viewApplicationData && viewApplicationData?.state_name?viewApplicationData?.state_name:viewApplicationData?.state,
      },

      {
        question: "City",
        answser: viewApplicationData && viewApplicationData.city,
      },
      {
        question: "Applicant LinkedIn URL",
        answser: viewApplicationData && viewApplicationData.appLindin_url,
      },
      {
        question: "Startup Website",
        answser: viewApplicationData && viewApplicationData.startupwebsite,
      },
      {
        question: "Startup or Product Video URL",
        answser: viewApplicationData && viewApplicationData.startup_video_url,
      },
      {
        question: "Upload Startup Deck or other Documents",
        answser: viewApplicationData && viewApplicationData.upload_document,
      },
      {
        question: "Current Revenue (Pro Rata)",
        answser: viewApplicationData && viewApplicationData.curret_revenue,
      },
      {
        question: "Core Services Offered by Startup",
        answser: viewApplicationData && viewApplicationData.offered_startup,
      },
      {
        question: "The Problem Being Solved by Startup",
        answser: viewApplicationData && viewApplicationData.problem_solved,
      },
      {
        question: "Why Do You Need Mentorship?",
        answser: viewApplicationData && viewApplicationData.whyneedMentorship,
      },
      {
        question: "What are Your Expected Outcomes from Mentorship Sessions?",
        answser: viewApplicationData && viewApplicationData.expected_outcome,
      },
    ];
    else {
      value = [
        {
          question: "Entity Name",
          answser: viewApplicationData && viewApplicationData.entity_name,
        },
        {
          question: "DPIIT Number",
          answser: viewApplicationData && viewApplicationData.dpiit_no,
        },
        {
          question: "Sector",
          answser: viewApplicationData && viewApplicationData.sector,
        },
        {
          question: "Industry",
          answser: viewApplicationData && viewApplicationData.industry,
        },
        {
          question: "Function",
          answser: viewApplicationData && viewApplicationData.services?viewApplicationData.services:"NA",
        },
        {
          question: "Stage",
          answser: viewApplicationData && viewApplicationData.stage,
        },
        {
          question: "Applicant Name",
          answser: viewApplicationData && viewApplicationData.applicant_name,
        },
        // {
        //   question: "Contact Number",
        //   // answser: viewApplicationData && viewApplicationData.contact_no,
        //   answser: viewApplicationData && "+" + newNumber,
        // },
        {
          question: "Designation",
          answser: viewApplicationData && viewApplicationData.designation,
        },
        {
          question: "Gender",
          answser: viewApplicationData && viewApplicationData.gender,
        },
        {
          question: "Country",
          answser: viewApplicationData && viewApplicationData.country_name,
        },
        {
          question: "State",
          answser: viewApplicationData && viewApplicationData?.state_name?viewApplicationData?.state_name:viewApplicationData?.state,
        },
  
        {
          question: "City",
          answser: viewApplicationData && viewApplicationData.city,
        },
        {
          question: "Applicant LinkedIn URL",
          answser: viewApplicationData && viewApplicationData.appLindin_url,
        },
        {
          question: "Startup Website",
          answser: viewApplicationData && viewApplicationData.startupwebsite,
        },
        {
          question: "Startup or Product Video URL",
          answser: viewApplicationData && viewApplicationData.startup_video_url,
        },
        {
          question: "Upload Startup Deck or other Documents",
          answser: viewApplicationData && viewApplicationData.upload_document,
        },
        {
          question: "Current Revenue (Pro Rata)",
          answser: viewApplicationData && viewApplicationData.curret_revenue,
        },
        {
          question: "Core Services Offered by Startup",
          answser: viewApplicationData && viewApplicationData.offered_startup,
        },
        {
          question: "The Problem Being Solved by Startup",
          answser: viewApplicationData && viewApplicationData.problem_solved,
        },
        {
          question: "Why Do You Need Mentorship?",
          answser: viewApplicationData && viewApplicationData.whyneedMentorship,
        },
        {
          question: "What are Your Expected Outcomes from Mentorship Sessions?",
          answser: viewApplicationData && viewApplicationData.expected_outcome,
        },
      ];
    }
    const value1 = [
      {
        question: "Industry",
        answser: viewApplicationData && viewApplicationData.industrydata,
      },
      {
        question: "Industry / Sector - Keywords",
        answser: viewApplicationData && viewApplicationData.subindustry,
      },

      {
        question: "Function",
        answser: viewApplicationData && viewApplicationData.preffered_function,
      },
      {
        question: "Function - Keywords",
        answser: viewApplicationData && viewApplicationData.subspecialization,
      },
      {
        question: "Current Stage of the Startup",
        answser: viewApplicationData && viewApplicationData.preffered_stages,
      },
    ];
    setStudents(value);
    setStudents1(value1);
  }, [viewApplicationData]);
  const renderTableData = () => {
    return students?.map((student, index) => {
      const { id, question, answser } = student; //destructuring
      return (
        <tr key={id}>
          <td className="question_name">
            <p>{question}</p>
          </td>
          {/* <td className="anwsers"> */}
          {/* <p>{answser}</p>
              </td> */}
          <td className="anwsers">
            {question === "Upload Startup Deck or other Documents" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 600, color: "#3AC2D7" }}
                >
                  {"View Document"}
                </a>
              )
            ) : question === "Applicant LinkedIn URL" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 600, color: "#3AC2D7" }}
                >
                  {answser}
                </a>
              )
            ) : question === "Startup Website" ? (
              answser && (
                <a
                href={answser}
                target="_blank"
                style={{ fontWeight: 600, color: "#3AC2D7" }}
              >
                {answser}
              </a>
              )
            ) : question === "Startup or Product Video URL" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 600, color: "#3AC2D7" }}
                >
                  {answser}
                </a>
              )
            ) : (
              <p>{answser}</p>
            )}
          </td>
        </tr>
      );
    });
  };
  const renderTableData1 = () => {
    return students1?.map((student, index) => {
      const { id, question, answser } = student; //destructuring
      return (
        <tr key={id}>
          <td className="question_name">
            <p>{question}</p>
          </td>

          <td className="anwsers">
            {question === "Industry" ||
            question === "Current Stage of the Startup" ||
            question === "Function" ||
            question === "Function - Keywords" ||
            question === "Industry / Sector - Keywords" ? (
              answser?.map((item, index) => <p key={index}>{item}</p>)
            ) : (
              <p>{answser}</p>
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="ViewApplication-StartupData pt-5">
      <div className="col-md-10 ViewApplication-detailwhole applicationstartupdetails124">
        <div>
          {/* <Button
            className="top-btn"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#3AC2D7",
              color: "#fff",
              width: "150px",
              marginTop: "20px",
              marginBottom: "20px",
              marginRight: "8px",
              display: "flex",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "25px",
              letterSpacing: "0.02857em",
              textTransform: "uppercase",
            }}
            onClick={() => handleClick()}>
          
            {" "}
            Back
          </Button> */}
          <div className="session-detailHeading">
            <p className="display-heading appliid123">
              APPLICATION ID :{" "}
              {viewApplicationData && getApplicationId(viewApplicationData.id)}
            </p>
            {(viewApplicationData?.upload_logo ==null && viewApplicationData?.upload_profile==null)?<img src={hashImage}/>:(
            <div style={{display:"flex"}}>
            {viewApplicationData && (
              <>
                <img
                  className="mentor-img"
                  // src={MentorImg}
                  //  style={{backgroundImage:hashImage}}
                  src={
                    viewApplicationData?.upload_logo !== null
                      ? viewApplicationData.upload_logo
                      : hashImage
                  }
                />
              </>
            )}
            {viewApplicationData && (
              <>
                <img
                  className="mentor-img"
                  // src={MentorImg}
                   style={{marginLeft:"20px"}}
                  src={
                    viewApplicationData?.upload_profile !== null
                      ? viewApplicationData.upload_profile
                      : hashImage
                  }
                />
              </>
            )}
            </div>)}
          </div>
        </div>

        <table id="session">
          <tbody>{renderTableData()}</tbody>
          <tbody>
           
         
                {/* {
                window.fromModule != undefined && window.fromModule != null &&

             window.fromModule != "startUpApplications" ? ( */}
                   <>
                  <tr>
                  <td style={{ borderRight: "0", backgroundColor: "#b499c7" }}></td>
                  <td style={{ borderLeft: "0", backgroundColor: "#b499c7" }}>
                  <div className="d-flex justify-content-center">
                    <div className="applicationDivision">
                      FIRST MENTORSHIP REQUIREMENT
                    </div>
                  </div>
                  </td>
            </tr>
            {renderTableData1()}
            </>
                {/* ):('')} */}
          </tbody>
        </table>

        {/* <table id="session">
    <tbody>
    
        <tr>
            <td className='session-question'><p> Entity Name</p></td>
            <td className='session-answer'><p>BLECAN INNOVATIONS PRIVATE LIMITED</p></td>
        </tr>
        <tr>
            <td className='session-question'><p> Applicant Name</p></td>
            <td className='session-answer'><p>Rishabh Agnihotri</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>DPIIT Number</p></td>
            <td className='session-answer'><p>DIPP10964</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Sector</p></td>
            <td className='session-answer'><p>Point of Sales</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Industry</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Function</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Stage</p></td>
            <td className='session-answer'><p>Validation</p></td>
        </tr>
        
        <tr>
            <td className='session-question'><p>Email</p></td>
            <td className='session-answer'><p>rishabh@poispay.com</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Contact Number</p></td>
            <td className='session-answer'><p>+91 9099926845</p> 
                  </td>
        </tr>
        <tr>
            <td className='session-question'><p>Designation</p></td>
            <td className='session-answer'><p>test</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Gender</p></td>
            <td className='session-answer'><p>Female</p>
                 </td>
        </tr>
        <tr>
            <td className='session-question'><p>Country</p></td>
            <td className='session-answer'><p>India</p>
                  </td>
        </tr>
        <tr>
            <td className='session-question'><p>State</p></td>
            <td className='session-answer'><p>Gujarat</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>City</p></td>
            <td className='session-answer'><p>Vadodara</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Applicant LinkedIN URL</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Startup Website</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Startup or Product Video URL</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Startup Deck or other Documents
</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Current Revenue (Pro Rata)</p></td>
            <td className='session-answer'><p>NA</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Core Services Offered By Startup</p></td>
            <td className='session-answer'><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>The Problem Being Solved By Startup</p></td>
            <td className='session-answer'><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Why Do You Need Mentorship</p></td>
            <td className='session-answer'><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>What Are Your Expected Outcomes From Mentorship Sessions</p></td>
            <td className='session-answer'><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p></td>
        </tr>
       
        <tr>
            <td style={{borderRight:"0",backgroundColor:"#b499c7"}}></td>
        <td style={{borderLeft:"0",backgroundColor:"#b499c7"}}>
        <div  className='d-flex justify-content-center'>
            <div className='applicationDivision'>
                        MENTORSHIP REQUEST
            </div>
        </div>
        </td>
        </tr>
        <tr>
            <td className='session-question'><p>Industry / Sector</p></td>
            <td className='session-answer'><p>Aeronautics Aerospace Defense<br/>Airport Operations</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Industry / Sector Keywords</p></td>
            <td className='session-answer'><p>Agri-Tech<br/>

Advisory</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Function</p></td>
            <td className='session-answer'><p>Fundraising<br/>

Compliance & Legal</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Function Keywords</p></td>
            <td className='session-answer'><p>BE<br/>

Audit</p></td>
        </tr>
        <tr>
            <td className='session-question'><p>Current Stage of the Startup </p></td>
            <td className='session-answer'><p>Validation</p></td>
        </tr>
       
        
       
        
    </tbody>
  </table> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    applicationData: state.AdminMentorViewReducer.getViewApplicationData.data,
  };
};

export default connect(mapStateToProps, {
  getViewApplicationData,
})(withRouter(ViewApplicationStartup));
